export const listUnStyled = `
    padding-left: 0;
    list-style: none;
    //  TODO: Shouldn't we remove also the margin?
`;
